<template>
    <section class="page-content settings">
        <div class="wrap btn-position-wrap">
            <div class="users-settings-list">
                <div class="item-wrap" v-if="releaseList === null">
                    <div class="line-item hovered-line">
                        <div class="left-ir u tem releaseListWraper">
                            <div class="block-1">
                            </div>
                            <div class="block-2">
                            </div>
                            <div class="block-3" style="padding-top:20px;">
                                No version found.
                            </div>
                            <div class="block-4">
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="item-wrap">
                    <div class="row mt-40 version-table">
                        <div class="col-sm-12 " v-bind:class="{ static: clinetVersionCheck}">
                            <table class="table table-bordered">
                                <thead>
                                <tr>
                                    <th style="width:100px;">Version</th>
                                    <th style="width:200px;"> Date</th>
                                    <th style="width:500px;"> Description</th>
                                    <th style="width:200px;" v-if="isAdmin"> Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(release, indexParent) in releaseList" :key="indexParent">
                                        <td style='text-align:center;vertical-align:top;padding-top: 20px;'> {{ release.v_no }}</td>
                                        <td style='text-align:center;vertical-align:top;padding-top: 20px; width:200px;'> {{ release.description[0]['date'] }}</td>
                                        <td colspan="4">
                                            <table class="version-iiner-table">
                                                <tr v-for="(releasebuild, index) in release.description" :key="index">
                                                    <span v-if="index <= 0">
                                                        <td v-for="(releasebuildss, indexss) in releasebuild.features" style="width:1000px;">
                                                            {{ releasebuildss.descriptionVersion }}
                                                        </td>
                                                        <td class="custom-btn" style="width:600px;"></td>
                                                        <td class="custom-btn" style='text-align:center;vertical-align:top;padding-top: 20px; width:200px;' v-if="isAdmin">
                                                            <md-button class="md-icon-button" @click="expandAll(rowStatus, indexParent)">
                                                                <i class="md-icon md-icon-font md-icon-image md-list-expand-icon md-theme-default"><svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"></path> <path d="M0-.75h24v24H0z" fill="none"></path></svg></i>
                                                            </md-button>
                                                            <md-button class="md-icon-button" v-if="!clinetVersionCheck && isAdmin" @click="showCurrentReleaseProfileVersion(releasebuild.id, release.v_no)">
                                                                <md-icon>mode_edit</md-icon>
                                                            </md-button>
                                                        </td>
                                                    </span>
                                                    <span v-show="rowStatus[indexParent]">
                                                        <thead v-if="showExpand">
                                                            <tr v-if="index === 0">
                                                                <th>Build</th>
                                                                <th>Feature</th>
                                                                <th>Description</th>
                                                                <th v-if="isAdmin">Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>{{ releasebuild.v_no }}.{{ releasebuild.r_no }}</td>
                                                                <td v-for="(releasebuilds, indexs) in releasebuild.features">
                                                                    {{ releasebuilds.heading }}
                                                                </td>
                                                                <td v-for="(releasebuilds, indexs) in releasebuild.features">
                                                                    {{ releasebuilds.description }}
                                                                </td>
                                                                <td class="custom-btn" v-if="!clinetVersionCheck && isAdmin">
                                                                    <md-button class="md-icon-button" v-if="isAdmin" @click="showCurrentReleaseProfile(releasebuild.id, release.v_no)">
                                                                        <md-icon>mode_edit</md-icon>
                                                                    </md-button>
                                                                </td>
                                                            </tr>
                                                      </tbody>
                                                  </span>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom-btn-position" v-if="isSuperAdmin">
                <div class="wrap">
                    <md-button @click="clickAddNewRelease()" class="add-tour-button md-fab md-accent md-primary">
                        <md-icon>add</md-icon>
                    </md-button>
                </div>
            </div>
        </div>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialog">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Are you sure you want to delete release<b> {{ this.releaseToDeleteName }}</b>? This action cannot be undone.
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="deleteSelectedRelease()">DELETE</md-button>
                <md-button class="ManualBtn ManualBtncancel" @click="closeDialog()">CANCEL</md-button>
            </md-dialog-actions>
        </md-dialog>
    </section>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import {deleteRelease} from '../../services/ReleaseService.js';

export default {
  data: () => ({
    showDeleteDialog: false,
    releaseIdToDelete: null,
    releaseToDeleteName: null,
    rowStatus: [],
    showExpand: false
  }),
  props: ['clinetVersionCheck', 'latestVersion'],
  computed: {
    ...mapGetters('client', ['clientActive', 'currentClient']),
    ...mapGetters('user', ['userList', 'isAdmin', 'isSuperAdmin', 'currentUser']),
    ...mapGetters('release', ['releaseList'])
  },
  methods: {
    ...mapActions('user', ['loadUserList', 'setUserToEdit']),
    ...mapActions('release', ['loadReleaseList', 'setReleaseToEdit', 'setReleaseToEditVersion']),
    clickAddNewRelease () {
      this.$router.replace('/settings/release/add');
    },
    expandAll (status, index) {
      this.showExpand = true;
      this.$set(this.rowStatus, index, (this.rowStatus[index] ? 0 : 1));
    },
    confirmDelete (releaseId, releasebuildRNo) {
      this.showDeleteDialog = true;
      this.releaseIdToDelete = releaseId;
      this.releaseToDeleteName = releasebuildRNo;
    },
    closeDialog () {
      this.showDeleteDialog = false;
      this.releaseIdToDelete = null;
      this.releaseToDeleteName = null;
    },
    async deleteSelectedRelease () {
      await deleteRelease(this.releaseIdToDelete)
        .then(response => {
          this.loadReleaseList();
        })
        .catch(error => {
          console.log(error.response.data);
        });
      this.showDeleteDialog = false;
      this.releaseIdToDelete = null;
      this.releaseToDeleteName = null;
      this.loadReleaseList(this.currentUser.id);
    },
    loadUsers () {
      if (this.clientActive) {
        this.loadUserList(this.currentClient.id);
      } else {
        this.loadUserList();
      }
    },
    showCurrentReleaseProfile (releaseId, releaseVersionNo) {
      for (let release of this.releaseList) {
        if (release.v_no === releaseVersionNo) {
          for (let build of release.description) {
            if (build.id === releaseId) {
              this.setReleaseToEdit(build);
              this.$router.push('/settings/release/edit');
              return;
            }
          }
        }
      }
    },
    showCurrentReleaseProfileVersion (releaseId, releaseVersionNo) {
      for (let release of this.releaseList) {
        if (release.v_no === releaseVersionNo) {
          for (let build of release.description) {
            if (build.id === releaseId) {
              this.setReleaseToEditVersion(build);
              this.$router.push('/settings/release/editVersion');
              return;
            }
          }
        }
      }
    }
  },
  created () {
    this.loadReleaseList(this.currentUser.id);
  },
  mounted () {
    this.loadUsers();
  }
};
</script>

<style lang="scss" scoped>
.static {
    overflow-y: scroll;
    height: 500px;
}

.bottom-btn-position {
    position: fixed !important;
    right: 12px !important;
    bottom: 32px !important;
    width: 500px;
    padding-right: 35px;

    button {
        z-index: 15;
    }
}

.wrap {
    padding-top: 0 !important;
}

.hovered-line:hover {
    background-color: rgba(0, 0, 0, 0.2);
}

.user-item {
    cursor: pointer;
}

.ManualBtndelete {
    background-color: #d9534f !important;
}

.ManualBtncancel {
    color: white !important;
    background-color: #00a8ca !important;
    border-color: #ccc !important;
}

.ManualBtn {
    display: inline-block !important;
    margin-bottom: 0 !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    -ms-touch-action: manipulation !important;
    touch-action: manipulation !important;
    cursor: pointer !important;
    background-image: none !important;
    border: 1px solid transparent !important;
    padding: 6px 12px !important;
    font-size: 14px !important;
    line-height: 1.42857143 !important;
    border-radius: 4px !important;
    color: #fff !important;
}

.full-btn {
    padding-right: 20px !important;
    padding-left: 10px !important;
}

.left-item.releaseListWraper {
    float: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
}

.left-item.releaseListWraper .block-1 {
    display: flex;
    flex: 0 0 20%;
}

.left-item.releaseListWraper .block-2 {
    display: flex;
    flex: 0 0 25%;
}

.left-item.releaseListWraper .block-3 {
    display: flex;
    flex: 0 0 20%;
}

.left-item.releaseListWraper .block-4 {
    display: flex;
    flex: 0 0 25%;
}

.left-item.releaseListWraper .block-5 {
    display: flex;
    flex: 0 0 10%;
}


.left-item.releaseListWraper .block-5 {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
}

.mt-40 {
    margin-top: 40px;
}

.version-table {
    margin-bottom: 30px;
}

.version-table table {
    width: 100%;
}

.version-table table thead tr {
    background-color: #00A8CA;
    color: #fff;
    text-align: left;
}

.d-flex {
    display: flex;
}

.version-table table thead tr th, .version-table table tbody tr td {
    padding: 10px;
}

.version-iiner-table tr td {
    vertical-align: top;
}

.version-iiner-table tr td:first-child {
    width: 200px;
}

.version-iiner-table tr td:nth-child(2) {
    width: 190px;
}

.version-iiner-table tr td:nth-child(3) {
    width: 350px;
}

.custom-btn .md-icon-button {
    display: unset !important;
}

button.md-button.ManualBtn.ManualBtndelete.md-theme-default span.md-button-content {
    font-size: 15px;
}

button.md-button.ManualBtn.ManualBtncancel.md-theme-default span.md-button-content {
    font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/client/ReleaseSettings.vue